<template>
    <div style="background-color:#F5F7FA">
        <div class="BasicInfo" style="padding: 10px 15px;background-color: #fff;">
            <div style="color: #4D586D;font-size: 13px;margin-bottom: 6px;">订单号:{{orderInfo.order_code}}</div>
            <div style="color: #4A90E2;font-size: 12px;margin-bottom: 6px;">{{orderInfo.store_name}}</div>
            <div style="display: flex;margin-bottom: 6px;">
                <div style="color: #C6CCCF;font-size: 12px">品种数：{{orderInfo.varietiescount}}</div>
                <div style="color: #C6CCCF;font-size: 12px;margin-left: 10px">下单时间：{{orderInfo.created_date}}</div>
            </div>
            <div style="display: flex;margin-bottom: 6px;">
                <div>
                    <span style="border: 1px solid #FFA200;color:#fff;font-size: 12px;background-color: #FFA200;border-radius: 3px;padding: 2px">总金额</span><span
                        style="color: #FFA200;font-size: 12px;padding-left: 10px">￥{{orderInfo.total}}</span>
                </div>
                <div style="padding: 0px 5px">
                    <span style="color: #FFA200;font-size: 15px">|</span>
                </div>
                <div>
                    <span style="color: #FFA200;font-size: 12px">支付方式：{{orderInfo.pay_type}}</span>
                </div>
            </div>
            <div style="color: #4A4A4A;font-size: 10px;margin-top: 8px">
                创建人：{{orderInfo.created_by_name}}
            </div>
        </div>
        <div class="tableInfo" style="background-color: #fff">
            <table rules="rows" style=" width: 100%">
                <tr style=" border-bottom: 1px solid #979797;background-color: #E0E0E0;border: none;height: 35px;line-height: 35px;">
                    <th style="border: none;font-size: 13px;color: #5C575E;text-align: left;padding-left: 14px">商品信息
                    </th>
                    <th style="border: none;font-size: 13px;color: #5C575E">单价</th>
                    <th style="border: none;font-size: 13px;color: #5C575E">数量</th>
                    <th style="border: none;font-size: 13px;color: #5C575E">单位</th>
                    <th style="border: none;font-size: 13px;color: #5C575E">小计</th>
                </tr>
                <tr v-for="(item,index) in orderInfo.skuArr">
                    <td style="border: none;text-align: center;text-align: left;padding-left: 14px;padding-top: 8px;"
                        valign="top">
                        <div style="font-size: 12px;color: #4D586D;padding-bottom: 5px;">{{item.goodsname}}</div>
                        <div style="font-size: 12px;color: #4D586D;padding-bottom: 5px;">{{item.goodsname}}</div>
                        <div style="font-size: 8px;color: #979797;padding-bottom: 5px;">{{item.goodsspec}}</div>
                        <div style="font-size: 9px;color: #4A90E2;padding-bottom: 5px;">{{item.brandname}}</div>
                    </td>
                    <td style="border: none;text-align: center;font-size: 12px" valign="top">
                        <div style="font-size: 12px;color: red;text-decoration:line-through;padding-bottom: 5px;">
                            {{item.unitprice}}
                        </div>
                        <div style="font-size: 12px;padding-bottom: 5px;">{{item.editprice}}</div>
                    </td>
                    <td style="border: none;text-align: center;font-size: 12px" valign="top">{{item.goodsnum}}</td>
                    <td style="border: none;text-align: center;font-size: 12px" valign="top">{{item.goodsunitname}}</td>
                    <td style="border: none;text-align: center;font-size: 12px" valign="top">
                        <div style="font-size: 12px;color: red;text-decoration:line-through;">{{item.unitprice *
                            item.goodsnum}}
                        </div>
                        <div style="font-size: 12px"> {{item.editprice * item.goodsnum}}</div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="InputInfo" style="margin-top: 20px;background-color: #fff">
            <div style="border-bottom: 1px solid #F6F6F6;padding: 10px;display: flex">
                <div style="color:#929297;font-size: 14px;display: block;width:91px;flex-shrink: 0">付款方式</div>
                <div style="flex-grow: 1;word-break:break-all;color: #87909A;font-size: 14px">
                    {{orderInfo.pay_type}}
                </div>
            </div>
            <div style="border-bottom: 1px solid #F6F6F6;padding: 10px;display: flex">
                <div style="color:#929297;font-size: 14px;display: block;width:91px;flex-shrink: 0">收货地址</div>
                <div style="flex-grow: 1;word-break:break-all;color: #87909A;font-size: 14px">
                    <div style="font-size: 14px;color: #87909A">
                        我的地址
                    </div>
                    <div style="color: #4A90E2;font-size: 14px;margin-top: 5px;">
                        {{orderInfo.address}}
                    </div>
                </div>
            </div>
            <div style="border-bottom: 1px solid #F6F6F6;padding: 10px;display: flex">
                <div style="color:#929297;font-size: 14px;display: block;width:91px;flex-shrink: 0">配送方式</div>
                <div style="flex-grow: 1;word-break:break-all;color: #87909A;font-size: 14px">
                    {{orderInfo.post_type}}
                </div>
            </div>
            <div style="border-bottom: 1px solid #F6F6F6;padding: 10px;display: flex">
                <div style="color:#929297;font-size: 14px;display: block;width:91px;flex-shrink: 0">联系人</div>
                <div style="flex-grow: 1;word-break:break-all;color: #87909A;font-size: 14px">
                    {{orderInfo.name}}
                </div>
            </div>
            <div style="border-bottom: 1px solid #F6F6F6;padding: 10px;display: flex">
                <div style="color:#929297;font-size: 14px;display: block;width:91px;flex-shrink: 0">联系电话</div>
                <div style="flex-grow: 1;word-break:break-all;color: #87909A;font-size: 14px">
                    {{orderInfo.phone}}
                </div>
            </div>
            <div style="border-bottom: 1px solid #F6F6F6;padding: 10px;display: flex;height: calc(100vh - 90vh)">
                <div style="color:#929297;font-size: 14px;display: block;width:91px;flex-shrink: 0">留言</div>
                <div style="flex-grow: 1;word-break:break-all;color: #87909A;font-size: 14px">
                    {{orderInfo.comments}}
                </div>
            </div>
        </div>
        <div class="foolt" style="text-align: center;">
            <el-button size="medium" style="width: 80%" type="primary" v-if="status=='APPROVAL'" @click="confirmOrder">
                确认订单
            </el-button>
        </div>
    </div>
</template>

<script>
  import http from '../../APIService/http'
  import axios from "axios"

  export default {
    name: 'orderInfo',
    data () {
      return {
        orderInfo: {},
        key_id: '',
        tenant_id: '',
        status: '',
        access_token:"",
      }
    },
    created () {
      let test = window.location.href
      let strArr = test.split('?')[1]
      let s = strArr.split('&')
      let tempId = s[0].split('=')[1]
      this.key_id = tempId.split('tenant')[0]
      this.tenant_id = tempId.split('tenant')[1]
      this.GkOrderInfo()

    },
    methods: {
      encode (str) {
        let encode = encodeURI(str)
        let base64 = btoa(encode)
        return base64
      },
      async GkOrderInfo () {
        let data = {
          tenant_id: this.tenant_id,
          key_id: this.key_id
        }
        await http.post('/b2b_sever/gkGetFeedback/GkOrderInfo', data).then(res => {
          if (res.success === true) {
            this.orderInfo = res.data
            this.status = res.data.status
          }
        })
      },

      async confirmOrder () {
        let data = {
          tenant_id: this.tenant_id,
          key_id: this.key_id
        }
        await http.post('/b2b_sever/gkGetFeedback/GkConfirmOrder', data).then(res => {
          // this.GkOrderInfoList()
          this.GkOrderInfo()
        })
      },
      //提交订单后返回的列表
      // async GkOrderInfoList () {
      //   let data = {
      //     tenant_id: this.tenant_id,
      //     key_id: this.key_id
      //   }
      //   await http.post('/wapi/gkGetFeedback/GkOrderInfoList', data).then(res => {
      //       let array = res.data.data
      //     console.log(array)
      //   })
      // },

      // async submitOrder () {
      //   let data = {
      //     subOrderSignVO: {
      //       orderPlatform: '1H5',
      //       orderFrom: '买家下单',
      //       orderType: '普通订单',
      //       createBy: '3326431435',
      //       createByName: this.orderInfo.created_by,
      //       goodsTotalValue: this.orderInfo.total,
      //       orderValue: this.orderInfo.orderValue,
      //       useAddress: this.orderInfo.address,
      //       useDelivery: this.orderInfo.post_type,
      //       buyerName: this.orderInfo.name,
      //       buyerTel: this.orderInfo.phone,
      //       SinoChannelPayVO: this.orderInfo.pay_type,
      //       orderMessage: this.orderInfo.comments,
      //       key: ''
      //     }
      //   }
      //   await http.post('http://test3.gyao511.com/blade-order/order/submitOrder', data).then(res => {
      //
      //   })
      // },

      // async token () {
      //
      //   let data = {
      //     'scope':'all',
      //     'userType':'5',
      //     'username':'13333333333',
      //     'password':'',
      //     'storeId':'1',
      //     'cysCode':'20190620102917121',
      //   }
      //   let headers = {
      //     'Authorization': 'Basic' + ' ' + this.encode('crm:crm_secret'),
      //     // 'Authorization': "Basic Y3JtOmNybV9zZWNyZXQ=",
      //     'Content-Type':"application/x-www-form-urlencoded"
      //   }
      //   await axios.post('/blade-auth/oauth/token', data,{headers}).then(res => {
      //     this.access_token =""
      //   })
      // },

    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/gkOrder/orderInfo.vue